module.exports = __webpack_public_path__ + "static/media/left-arrow.91883ab0.svg";